 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';

type RankChangeRendererProps = {
  change?: number | null;
};

const RankChangeRenderer = ({ change }: RankChangeRendererProps) => {
  return (
    <div className="d-flex h-100 align-items-center justify-content-around">
      {change && (
        <h6
          className={classNames('mb-0', {
            'text-danger': change < 0,
            'text-success': change > 0
          })}
        >
          {change <= 100 && change >= -100 ? (
            <>
              {change < 0 ? -1 * change : change}
              {change > 0 ? (
                <FontAwesomeIcon icon="caret-up" className="ms-1" />
              ) : change < 0 ? (
                <FontAwesomeIcon icon="caret-down" className="ms-1" />
              ) : (
                ''
              )}
            </>
          ) : (
            <>
              {change > 0 ? 'ورود' : 'خروج'}
              {change > 0 ? (
                <FontAwesomeIcon icon="caret-right" className="ms-1" />
              ) : (
                <FontAwesomeIcon icon="caret-left" className="ms-1" />
              )}
            </>
          )}
        </h6>
      )}
    </div>
  );
};

export default RankChangeRenderer;
